import { render, staticRenderFns } from "./BankReferencesCN.vue?vue&type=template&id=346008ac"
import script from "./BankReferencesCN.vue?vue&type=script&lang=js"
export * from "./BankReferencesCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports